import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import axios from 'axios';
import Loading from '../../components/Loading';
import NoResult from '../../components/general/NoResult';
import Helmet from 'react-helmet';
import Tooltip from 'rc-tooltip';
import Confirm from '../../components/Confirm.js';
import General from '../../modules/General';

class Startup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading:true,
            isError:false,
            askDelete:false,
            config:[],
        }

        this.taskElement = this.taskElement.bind(this);
        this.cartReminder = this.cartReminder.bind(this);
        this.emailCollection = this.emailCollection.bind(this);
        this.cartReminderFollowUp = this.cartReminderFollowUp.bind(this);
    }

    cartReminder() {
        return this.taskElement({
            link:'/builder/email/picker/1',
            image:'/images/cart.png',
            completed:this.state.config.cart_reminder ? true:false,
            title:'Add a cart reminder e-mail',
            description:'Send an e-mail notification to customers who abandons their cart',
            help:'https://crall.zendesk.com/hc/no/articles/360021797992-Hva-er-en-glemt-handlekurv-e-post-',
        });
    }

    emailCollection() {
        return this.taskElement({
            link:'/builder/popup/picker/1',
            image:'/images/envelope.png',
            completed:this.state.config.email_collection ? true:false,
            title:'Add a popup that collects e-mail addresses from visitors',
            description:'To improve send rate of our cart reminders we need to collect e-mails early as possible',
            help:'https://crall.zendesk.com/hc/no/articles/360022015731-Hvordan-opprette-en-popup',
        });
    }

    emailGrabber = () => {
        return this.taskElement({
            link:'/settings/emails',
            image:'/images/handshake.png',
            completed:this.props.general.settings.EMAIL_LOOKUP_STATUS == 1 ? true:false,
            title:'Collect e-mails and marketing consent',
            description:"Crall will monitor all visitor input to find e-mails. When we find an e-mail, we'll show a popup asking the visitor to allow us to send e-mails.",
            help:'https://crall.zendesk.com/hc/no/articles/360022017211-Innsamling-av-e-postadresser-og-samtykke',
        });
    }

    emailApp() {
        return this.taskElement({
            link:'/apps/browse',
            image:'/images/share.png',
            completed:this.state.config.email_app ? true:false,
            title:'Install an e-mail integration',
            description:'Transfer all collected e-mails directly into ESPs such as mailchimp, apsis etc.',
            help:'https://crall.zendesk.com/hc/no/articles/360022016191-Hvordan-automatisk-overf%C3%B8re-e-postadresser-til-din-ESP',
        });
    }

    birthday() {
        return this.taskElement({
            link:'/builder/email/picker/1',
            image:'/images/heart.png',
            completed:this.state.config.birthday ? true:false,
            title:'Send a birthday e-mail',
            description:'Automatically send an e-mail with a discount to customers on their birthday',
            help:'https://crall.zendesk.com/hc/no/articles/360021798012-Hvordan-opprette-en-e-post',
        });
    }

    cartReminderFollowUp() {
        return this.taskElement({
            link:'/emails',
            image:'/images/hourglass.png',
            completed:this.state.config.cart_reminder_followup ? true:false,
            title:'Create a follow-up for a cart reminder',
            description:"Send a new reminder to the visitor if they don't make a purchase after the previous cart reminder.",
            help:'https://crall.zendesk.com/hc/no/articles/360021798072-Hvordan-opprette-en-oppf%C3%B8lger-til-en-e-post-',
        });
    }

    segments() {
        return this.taskElement({
            link:'advanced',
            image:'/images/pie-chart.png',
            completed:this.state.config.birthday ? true:false,
            title:'Create automated e-mails based on visitor behavior',
            description:'Automatically send an e-mail to VIP customers, visitors who bought a specific product, bought from a manufacturer or category. The possibilities are endless. This is an advanced feature, please contact us for more information.',
        });
    }


    componentWillMount() {
        axios.get(`/general/startup`)
            .then(res => {
                this.setState({
                    ...this.state,
                    'isError':false,
                    'isLoading':false,
                    'config':res.data
                });
            })
            .catch(res => {
                this.setState({'isError':res.message});
            });

        localStorage.setItem('getting_started',1);
    }

    taskElement(options) {
        return (
            <li className="list-group-item">
                <div className="media">
                    <div className="media-left" style={{verticalAlign:'middle'}}>
                        <a className="avatar" style={{width:'100px',textAlign:'center'}} href="javascript:void(0)">
                            <img style={{width:'32px',borderRadius:0,display:'inline-block'}} className="img-fluid" src={options.image} alt="..." />
                        </a>
                    </div>
                    <div className="media-body">
                        <h4 className="media-heading">
                            {options.title}
                        </h4>
                        <small>{options.description}</small>
                        {
                            options.help ?
                                <p><br /><a href={options.help} target="blank" className="btn btn-sm btn-primary">Go to documentation</a></p>
                                :null
                        }
                    </div>
                    {
                        options.link != 'advanced' ?
                        <div className="media-right" style={{textAlign:'right',width:'20%'}}>
                            {
                                options.completed ?
                                    <button className="btn btn-success btn-block"><i className="icon fa-check-circle-o" aria-hidden="true"></i> Completed</button>
                                    :
                                    <Link to={General.Link(options.link)} className="btn btn-dark btn-block">Setup</Link>
                            }
                        </div>:null
                    }
                </div>
            </li>
        )
    }

    render() {
        if(this.state.isLoading) {
            return (
                <Loading error={this.state.isError} />
            );
        }

        return (
            <div className="full-height">
                <Helmet title="Getting started | Crall.io" />
                <div className="page-header">
                    <span className="page-title"><i className="icon wb-info-circle"></i> Getting started</span>
                    <div className="page-header-actions">
                        <Link to={General.Link("/dashboard")} className="btn btn-dark"><i className="icon fa-arrow-left" style={{marginRight:'10px'}}></i>  Return to dashboard</Link>
                    </div>
                </div>
                <div className="page-content">
                    <div className="col-sm-7 offset-sm-3">
                        <div className="panel panel-bordered" style={{border: "1px solid #e4eaec"}}>
                            <div className="panel-body">
                                <h3>Welcome to Crall, {this.props.auth.user.firstname}!</h3>
                                To help you get started, we've added a list of steps you should complete to optimize traffic, revenue and customer interaction.

                                <br /><br />
                                You may access this page again by clicking on "Getting started" in the top left.
                                <br /><br />
                                <h5>Need further assistance?</h5>
                                If you need any help, please check out our norwegian support center by clicking <a href="http://docs.crall.io">here</a> or by clicking "Help" in the menu to the left.
                                You can also use our chat in the bottom right to ask us questions or send an e-mail to hi@crall.io.
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-7 offset-sm-3">
                        <div className="panel panel-bordered" style={{border: "1px solid #e4eaec"}}>
                            <div className="panel-body">
                                <ul className="list-group list-group-full">
                                    {this.cartReminder()}
                                    {this.emailCollection()}
                                    {this.emailGrabber()}
                                    {this.cartReminderFollowUp()}
                                    {this.emailApp()}
                                    {this.birthday()}
                                    {this.segments()}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        )

    }
}

const mapStateToProps = (state) => {
    return {
        auth:state.auth,
        general:state.general,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({},dispatch)
}


Startup = connect(mapStateToProps,mapDispatchToProps)(Startup);
export default Startup;



// WEBPACK FOOTER //
// ./containers/startup/startup.js